import { render, staticRenderFns } from "./UserLayout1.vue?vue&type=template&id=4adc8002&scoped=true&"
import script from "./UserLayout1.vue?vue&type=script&lang=js&"
export * from "./UserLayout1.vue?vue&type=script&lang=js&"
import style0 from "./UserLayout1.vue?vue&type=style&index=0&id=4adc8002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc8002",
  null
  
)

export default component.exports